module.exports = __webpack_public_path__ + "img/sentinel-leader.23d63e15.png";